import { createSelector, createStructuredSelector } from "reselect";
import { initialState, State as EmailAuthenticatorState } from "./redux";
import { selectUserName } from "scenes/selectors";

/**
 * Direct selector to the emailAuthenticator state domain
 */

const selectEmailAuthenticatorDomain: (any) => EmailAuthenticatorState = (
  state
) => state.emailAuthenticator || initialState;

/**
 * Custom selectors to the emailAuthenticator state
 */
export const selectEmailAuthenticator = createSelector(
  selectEmailAuthenticatorDomain,
  (substate) => substate
);
export const selectEmailOtpLoading = createSelector(
  selectEmailAuthenticator,
  (substate) => substate.emailOtpLoading
);

export const selectEmailOtpError = createSelector(
  selectEmailAuthenticator,
  (substate) => substate.emailOtpError
);

export const selectEmailOtpVerifyDone = createSelector(
  selectEmailAuthenticator,
  (substate) => substate.emailOtpVerifyDone
);

export const selectEmailOtpRemoveDone = createSelector(
  selectEmailAuthenticator,
  (substate) => substate.emailOtpRemoveDone
);

export const selectCurrentFlow = createSelector(
  selectEmailAuthenticator,
  (substate) => substate.currentFlow
);

/**
 * Multi instance selectors exporting a factory
 */
export const makeSelectEmailAuthenticator = () =>
  createSelector(selectEmailAuthenticatorDomain, (substate) => substate);

// add structured selectors here, which will be mapped as prop to scene component
export default createStructuredSelector({
  emailOtpLoading: selectEmailOtpLoading,
  emailOtpError: selectEmailOtpError,
  emailOtpVerifyDone: selectEmailOtpVerifyDone,
  emailOtpRemoveDone: selectEmailOtpRemoveDone,
  username: selectUserName,
});
